<template>
  <div :class="rowClass">
    <!-- <AudioRecorder
      :attachmentTypeId="45"
      :attachmentTypeName="'attachment_type_center_execute'"
      :afterUploadService="handleCreateAttachment"
      :successfullyMessage="$lang.successfullySendedAudio"
      :caption="generateFileCaption"
      :isDisabled="!hasItemPermission(['AUDIO_RECORD'])"
    /> -->
    <AudioRecorderNew
      :uploadUrl="url"
      :attachmentTypeId="45"
      :attachmentTypeName="'attachment_type_center_execute'"
      :caption="generateFileCaption"
      :isDisabled="!hasItemPermission(['AUDIO_RECORD'])"
    />
  </div>
</template>

<script>
import { AudioRecorderNew } from "@/components/re-design";
import { computed, inject, ref, toRefs } from "vue";
import { pathOr } from "ramda";
import { setPersonContent } from "@/services/global-services";
import {
  generateApiUrl,
  generateCurrentRoute,
  generateError,
  generateLang,
  generateStoreGetters,
  getCurrentDateTime,
} from "@/shared/utils";
import { createAttachment } from "@/modules/kanoon/services";

export default {
  components: { AudioRecorderNew },
  props: {
    exerciseName: {
      type: String,
      default: "",
    },
    candidateName: {
      type: String,
      default: "",
    },
    candidateId: {
      type: String,
      default: "",
    },
    assessorId: {
      type: String,
      default: "",
    },
    rowClass: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const { exerciseName, candidateName, rowClass } = toRefs(props);

    const hasItemPermission = inject("hasItemPermission");

    const currentUserInfo = computed(() => generateStoreGetters(["userInfo"]));
    const caseId = computed(() => generateCurrentRoute(["params", "caseId"]));
    const centerExecuteId = computed(() =>
      generateCurrentRoute(["params", "centerExecuteId"])
    );
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseAttachments"],
      [caseId.value]
    );

    const generateFileCaption = computed(() => {
      return `${generateLang(["kanoon_audio"])} - ${centerExecuteId.value} - ${
        caseId.value
      } - ${props.candidateId} - ${props.assessorId}`;
    });
    const generatePersonContentDescription = computed(() => {
      const name = pathOr(null, ["person", "name"], currentUserInfo.value);
      const family = pathOr(null, ["person", "family"], currentUserInfo.value);
      const currentUserFullName = `${name} ${family}`;
      return `${generateLang(["audio"])} ${exerciseName.value} ${generateLang([
        "for",
      ])} ${centerExecuteId.value} ${generateLang([
        "by",
      ])} ${currentUserFullName}`;
    });

    const personContentId = ref(null);
    const setCenterExecutePersonContent = async () => {
      try {
        const resourceName = "center_execute_case";
        const reference = {
          resource: resourceName,
          key: caseId.value,
        };
        const response = await setPersonContent({
          resourceName,
          resourceId: caseId.value,
          name: generateFileCaption.value,
          description: generatePersonContentDescription.value,
          reference,
        });

        const { id } = response;
        personContentId.value = id;
      } catch (error) {
        generateError(error);
        throw error;
      }
    };

    const handleCreateAttachment = async (tempFile) => {
      try {
        const files = [tempFile];
        const response = await createAttachment(caseId.value, files);
        return response;
      } catch (error) {
        generateError(error);
      }
    };

    // return data to be used in template
    return {
      rowClass,
      personContentId,
      hasItemPermission,
      generateFileCaption,
      handleCreateAttachment,
      url,
    };
  },
};
</script>

<style></style>
